import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Modal,
  Drawer,
  Divider,
  TableSortLabel,
  Collapse,
  Checkbox,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import ClearIcon from "@mui/icons-material/Clear";
import { getJobWithProducts, deleteSelectedFile } from "../Service";
import moment from "moment";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import GradingIcon from "@mui/icons-material/Grading";
import CheckIcon from "@mui/icons-material/Check";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import BtnUpdFileIcon from "../../img/UploadFileWhite.png";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { dataAccessPermission } from "../../utils/dataAccessPermission";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { signOut } from "../../utils/signOut";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const monthTH = [
  { short: "ม.ค.", full: "มกราคม", num: "01" },
  { short: "ก.พ.", full: "กุมภาพันธ์", num: "02" },
  { short: "มี.ค.", full: "มีนาคม", num: "03" },
  { short: "เม.ย.", full: "เมษายน", num: "04" },
  { short: "พ.ค.", full: "พฤษภาคม", num: "05" },
  { short: "มิ.ย.", full: "มิถุนายน", num: "06" },
  { short: "ก.ค.", full: "กรกฎาคม", num: "07" },
  { short: "ส.ค.", full: "สิงหาคม", num: "08" },
  { short: "ก.ย.", full: "กันยายน", num: "09" },
  { short: "ต.ค.", full: "ตุลาคม", num: "10" },
  { short: "พ.ย.", full: "พฤศจิกายน", num: "11" },
  { short: "ธ.ค.", full: "ธันวาคม", num: "12" },
];

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AddJob({ onAddJob }) {
  const [t, i18n] = useTranslation("global");

  const [dataProduct, setDataProduct] = useState([]);

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProdSplitLine, setSelectedProdSplitLine] = useState(null);

  const [openModalVDO, setOpenModalVDO] = useState(true);
  const handleCloseVDO = () => {
    setOpenModalVDO(false);
  };

  const fileRef = useRef(null);
  const location = useLocation();
  const [value, setValue] = useState(
    location.state?.dataMonth
      ? `${location.state?.dataYear}-${location.state?.dataMonth}`
      : moment().format("YYYY-MM")
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [sumErrorMsg, setSumErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingSh, setLoadingSh] = useState(false);

  const [fileType, setFileType] = React.useState("");
  const [fileTypeCode, setFileTypeCode] = React.useState("");

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setErrorMsg("");
  };
  const handleClearSearchProduct = () => {
    setSearchInput("");
    setSelected([]); // Clear selected row
  };

  const [openNonSearch, setOpenNonSearch] = useState(false);
  const handleOpenNonSearch = () => setOpenNonSearch(true);
  const handleCloseNonSearch = () => {
    setOpenNonSearch(false);
    setErrorMsg("");
  };

  const [openModal, setOpenModal] = useState(false);
  const [loadingbutton, setloadingbutton] = useState(false);
  const handleOpenModal = () => setOpenModal(true);

  const [openModalMultidelete, setOpenModalMultidelete] = useState(false);
  const [openModaldelete, setOpenModaldelete] = useState(false);
  const [loadingbuttondelete, setloadingbuttondelete] = useState(false);
  const handleOpenModaldelete = () => {
    setOpenModaldelete(true);
  };
  const handleCloseModaldelete = () => setOpenModaldelete(false);

  const handleOpenModalMultidelete = () => {
    setOpenModalMultidelete(true);
  };
  const handleCloseModalMultidelete = () => setOpenModalMultidelete(false);

  const [openModalInsert, setOpenModalInsert] = useState(false);
  const [loadingBtnGrounding, setLoadingBtnInsert] = useState(false);
  const handleOpenModalGrounding = () => {
    setOpenModalInsert(true);
  };
  const handleCloseModalInsert = () => setOpenModalInsert(false);

  const handleClickModalInsert = () => {
    setLoadingBtnInsert(true);
    insertMultiJobs();
  };

  const insertMultiJobs = () => {
    // Filter data based on isChecked then Remove the isChecked field from each item
    const checkedItems = dataProduct.filter((item) =>
      selected.includes(item.GroupID)
    );
    checkedItems.map((item) => {
      onAddJob(item);
    });

    // Close confirm popup
    setLoadingBtnInsert(false);
    handleCloseModalInsert();

    // Close Add product window
    setOpenModalInsert(false);

    // Clear selected row
    setSelected([]);
  };

  const [loadingButtonUpDS, setLoadingButtonUpDS] = useState(false);
  const [openModalUpdateDS, setOpenModalUpdateDS] = useState(false);
  const handleOpenModalUpdateDS = () => {
    setOpenModalUpdateDS(true);
  };
  const handleCloseModalUpdateDS = () => setOpenModalUpdateDS(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("GroupID");
  const [selected, setSelected] = useState([]);
  const [openRow, setOpenRow] = useState(null);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelect = (id) => {
    const newSelected = selected.includes(id)
      ? selected.filter((item) => item !== id)
      : [...selected, id];
    setSelected(newSelected);
  };

  const handleRowToggle = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const sortedData = [...dataProduct].sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });

  const headCells = [
    {
      id: "code",
      numeric: false,
      disablePadding: true,
      sortKey: "GroupID",
      label: t("product.table.header.code"),
    },
    {
      id: "job",
      numeric: false,
      disablePadding: true,
      sortKey: "GroupName",
      label: t("product.table.header.job"),
    },
    {
      id: "uom",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("product.table.header.uom"),
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("product.table.header.description"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      sortKey: "LaborCost",
      label: t("product.table.header.job_labor_price"),
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("genboq.table.header.action"),
    },
  ];

  const subHeadCells = [
    {
      id: "code",
      numeric: false,
      disablePadding: true,
      label: t("product.table.header.code"),
    },
    {
      id: "product",
      numeric: false,
      disablePadding: true,
      label: t("product.table.header.product"),
    },
    {
      id: "uom",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.uom"),
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.description"),
    },
    {
      id: "model",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.model"),
    },
    {
      id: "matprice",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.labor_price"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.price"),
    },
    {
      id: "PriceHomepro",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceHome"),
      align: "center",
    },
    {
      id: "PriceThaiWat",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceThai"),
      align: "center",
    },
    {
      id: "PriceBoon",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceBoon"),
      align: "center",
    },
    {
      id: "Other",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceOth"),
      align: "center",
    },
    {
      id: "reference",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.ref"),
    },
    {
      id: "searchon",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.last"),
    },
  ];

  // Snack Bar
  const vertical = "top";
  const horizontal = "right";
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [progress, setProgress] = React.useState(0);
  const [data, setData] = useState({ total: 0 });

  React.useEffect(() => {
    getData(0, rowsPerPage);
  }, []);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const getData = async (nowPage, nowRowsPerPage) => {
    setSelected([]); // Clear selected row
    setLoading(true);

    const role = dataAccessPermission("OWNER");

    var nowPages = nowPage + 1;

    let qString = `?page=${nowPages}&perpage=${nowRowsPerPage}`;
    qString += `&UserRole=${role}`;
    if (searchInput) qString = qString + "&KeyWord=" + searchInput;

    getJobWithProducts(qString).then((res) => {
      if (res && res.status === 200) {
        // For paginate
        setDataProduct(res.data.data);
        setData(res.data);
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: res.data.message,
          text: res.data.error,
        });
      }
      setLoading(false);
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, event.target.value);
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter" && searchInput.length > 0) {
      // Handle the Enter key press
      setPage(0);
      getData(0, rowsPerPage);
    }
  };
  const handleChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleRemove = (jsonData) => {
    setFile(null);
    setFileName(null);

    fileRef.current.value = "";
  };

  const handleClickSearch = () => {
    setPage(0);
    getData(0, rowsPerPage);
  };

  let NumberForm = new Intl.NumberFormat("th-TH", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  // Copy to clipboard
  const handleCopyClick = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setOpenSnack(true);
    });
  };

  return (
    <Box>
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={t("common.message.copy")}
      />

      {/*  ////////////////////////// Search Box ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          paddingBottom: "20px",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              minWidth: { lg: "500px", md: "500px" },
              display: "flex",
              mr: 2,
            }}
          >
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              // placeholder="Search here"
              placeholder={t("genboq.modal.addjob.txtbox.search")}
              size="middle"
              variant="outlined"
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: searchInput ? "visible" : "hidden",
                    }}
                    onClick={handleClearSearchProduct}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              value={searchInput}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </Box>

          <Box>
            <LoadingButton
              onClick={handleClickSearch}
              loading={loadingSh}
              loadingIndicator="Loading…"
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#5C5C5C",
                color: "#FFFFFF",
                borderRadius: "10px",
                height: "45px",
                textTransform: "none",
                width: "100px",
              }}
            >
              {t("common.button.search")}
            </LoadingButton>
          </Box>
        </Box>
        <Box>
          {selected.length > 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ mr: 2 }}>
                  <Typography>
                    {t("genboq.popup.addjob.sel")}
                    {selected.length}
                    {t("genboq.popup.addjob.unit")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", mr: 2 }}>
                  <Button
                    onClick={handleOpenModalGrounding}
                    variant="contained"
                    size="medium"
                    style={{
                      textTransform: "none",
                      borderRadius: "10px",
                      height: "45px",
                      backgroundColor: "#7399D1",
                    }}
                  >
                    {/* Insert */}
                    {t("genboq.button.insertjob")}
                  </Button>
                </Box>
              </Box>
            </>
          ) : (
            ""
          )}
        </Box>
      </Box>

      {/*  ////////////////////////// Data Table ////////////////////////// */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                padding="checkbox"
                sx={{
                  backgroundColor: "#c4e6ff",
                }}
              >
                <Checkbox
                  checked={
                    selected.length === dataProduct.length &&
                    dataProduct.length !== 0
                  }
                  onChange={() =>
                    setSelected(
                      selected.length === dataProduct.length
                        ? []
                        : dataProduct.map((item) => item.GroupID)
                    )
                  }
                />
              </TableCell>
              {headCells.map((headCell, index) => (
                <TableCell
                  key={index}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                  sx={{
                    backgroundColor: "#c4e6ff",
                    padding: "10px",
                    fontWeight: "bold",
                    color: "#1D589D",
                  }}
                  sortDirection={orderBy === headCell.sortKey ? order : false}
                >
                  {headCell.sortKey !== null ? (
                    <TableSortLabel
                      active={orderBy === headCell.sortKey}
                      direction={orderBy === headCell.sortKey ? order : "asc"}
                      onClick={() => handleRequestSort(headCell.sortKey)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  ) : (
                    headCell.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={13}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color="inherit" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : sortedData.length > 0 ? (
              sortedData.map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selected.includes(row.GroupID)}
                        onChange={() => handleSelect(row.GroupID)}
                      />
                    </TableCell>
                    <TableCell
                      width={80}
                      style={{
                        maxWidth: "80px",
                        minWidth: "50px",
                      }}
                    >
                      {row.GroupID}
                    </TableCell>
                    <TableCell
                      scope="row"
                      padding="none"
                      width={350}
                      style={{
                        maxWidth: "500px",
                        minWidth: "400px",
                      }}
                    >
                      <Typography variant="body1">{row.GroupName}</Typography>
                    </TableCell>
                    <TableCell width={80} style={{ maxWidth: "100px" }}>
                      {row.UoMGroup}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        minWidth: "200px",
                        maxWidth: "300px",
                      }}
                    >
                      <Typography variant="body1">
                        {row.GroupDescribe}
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      width={50}
                      style={{
                        minWidth: "50",
                        maxWidth: "80px",
                      }}
                    >
                      {NumberForm.format(row.LaborCost)}
                    </TableCell>

                    <TableCell width={60} style={{ maxWidth: "80px" }}>
                      {row.item_material.length > 0 ? (
                        <IconButton
                          onClick={() => handleRowToggle(row.GroupID)}
                        >
                          {openRow === row.GroupID ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} style={{ padding: 0 }}>
                      <Collapse
                        in={openRow === row.GroupID}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={{ marginTop: 0 }}>
                          <Table size="small" aria-label="purchases">
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  padding="checkbox"
                                  sx={{ backgroundColor: "#c4e6ff" }}
                                  style={{
                                    borderBottom: "2px solid gray",
                                    borderTop: "none",
                                  }}
                                ></TableCell>

                                {subHeadCells.map((subHead, index) => (
                                  <TableCell
                                    key={index}
                                    align={subHead.numeric ? "right" : "left"}
                                    padding={
                                      subHead.disablePadding ? "none" : "normal"
                                    }
                                    sx={{
                                      color: "#1D589D",
                                      fontWeight: "bold",
                                      padding: "10px",
                                      backgroundColor: "#c4e6ff",
                                    }}
                                    style={{
                                      borderBottom: "2px solid gray",
                                      borderTop: "none",
                                    }}
                                  >
                                    {subHead.label}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {row.item_material.map((materialRow, index) => (
                                <TableRow key={index}>
                                  <TableCell padding="checkbox"></TableCell>
                                  <TableCell
                                    width={80}
                                    style={{
                                      maxWidth: "80px",
                                      minWidth: "50px",
                                    }}
                                  >
                                    {materialRow.IDItem}
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    padding="none"
                                    width={350}
                                    style={{
                                      minWidth: "400px",
                                      maxWidth: "500px",
                                    }}
                                  >
                                    <Typography variant="string">
                                      {materialRow.itemname}
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    width={80}
                                    style={{ maxWidth: "100px" }}
                                  >
                                    {materialRow.UoMItem}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                    }}
                                  >
                                    <Typography variant="body2">
                                      {materialRow.ItemDescription}
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "120px",
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <Typography variant="body2">
                                      {materialRow.model}
                                    </Typography>
                                  </TableCell>

                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.MaterialLaborCost
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.material_Price
                                    )}
                                  </TableCell>

                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.matPriceHome
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.matPriceThai
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.matPriceBoon
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(materialRow.matPriceOth)}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "150px",
                                    }}
                                    align="left"
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {materialRow.urlHome ? (
                                        <Button
                                          variant="text"
                                          style={{
                                            textTransform: "none",
                                            textAlign: "left",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            padding: 0,
                                          }}
                                          size="small"
                                        >
                                          <Typography
                                            style={{
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                            }}
                                            sx={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp: 1, // Limits to 1 lines
                                              textOverflow: "ellipsis",
                                              fontSize: "12px",
                                            }}
                                          >
                                            <a
                                              href={materialRow.urlHome}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                              }}
                                            >
                                              HomePro
                                            </a>
                                          </Typography>
                                        </Button>
                                      ) : (
                                        ""
                                      )}

                                      {materialRow.urlThai ? (
                                        <Button
                                          variant="text"
                                          style={{
                                            textTransform: "none",
                                            textAlign: "left",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            padding: 0,
                                          }}
                                          size="small"
                                        >
                                          <Typography
                                            style={{
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                            }}
                                            sx={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp: 1, // Limits to 1 lines
                                              textOverflow: "ellipsis",
                                              fontSize: "12px",
                                            }}
                                          >
                                            <a
                                              href={materialRow.urlThai}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                              }}
                                            >
                                              Thai watsadu
                                            </a>
                                          </Typography>
                                        </Button>
                                      ) : (
                                        ""
                                      )}

                                      {materialRow.urlBoon ? (
                                        <Button
                                          variant="text"
                                          style={{
                                            textTransform: "none",
                                            textAlign: "left",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            padding: 0,
                                          }}
                                          size="small"
                                        >
                                          <Typography
                                            style={{
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                            }}
                                            sx={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp: 1, // Limits to 1 lines
                                              textOverflow: "ellipsis",
                                              fontSize: "12px",
                                            }}
                                          >
                                            <a
                                              href={materialRow.urlBoon}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                              }}
                                            >
                                              Boonthavorn
                                            </a>
                                          </Typography>
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                      {materialRow.urlOth ? (
                                        materialRow.urlOth.startsWith(
                                          "https://"
                                        ) ? (
                                          <Button
                                            variant="text"
                                            style={{
                                              textTransform: "none",
                                              textAlign: "left",
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              padding: 0,
                                            }}
                                            size="small"
                                          >
                                            <Typography
                                              style={{
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                              }}
                                              sx={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                WebkitLineClamp: 1, // Limits to 1 lines
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                              }}
                                            >
                                              <a
                                                href={materialRow.urlOth}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                  textDecoration: "none",
                                                  color: "inherit",
                                                }}
                                              >
                                                Other
                                              </a>
                                            </Typography>
                                          </Button>
                                        ) : (
                                          <div>
                                            <Button
                                              variant="text"
                                              style={{
                                                textTransform: "none",
                                                textAlign: "left",
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                padding: 0,
                                              }}
                                              size="small"
                                              onClick={() => {
                                                handleCopyClick(
                                                  materialRow.urlOth
                                                );
                                              }}
                                            >
                                              <Typography
                                                style={{
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                }}
                                                sx={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  overflow: "hidden",
                                                  WebkitLineClamp: 1, // Limits to 1 lines
                                                  textOverflow: "ellipsis",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                Other
                                              </Typography>
                                            </Button>
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}
                                      {materialRow.urlOth2 ? (
                                        materialRow.urlOth2.startsWith(
                                          "https://"
                                        ) ? (
                                          <Button
                                            variant="text"
                                            style={{
                                              textTransform: "none",
                                              textAlign: "left",
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              padding: 0,
                                            }}
                                            size="small"
                                          >
                                            <Typography
                                              style={{
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                              }}
                                              sx={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                WebkitLineClamp: 1, // Limits to 1 lines
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                              }}
                                            >
                                              <a
                                                href={materialRow.urlOth2}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                  textDecoration: "none",
                                                  color: "inherit",
                                                }}
                                              >
                                                Other2
                                              </a>
                                            </Typography>
                                          </Button>
                                        ) : (
                                          <div>
                                            <Button
                                              variant="text"
                                              style={{
                                                textTransform: "none",
                                                textAlign: "left",
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                padding: 0,
                                              }}
                                              size="small"
                                              onClick={() => {
                                                handleCopyClick(
                                                  materialRow.urlOth2
                                                );
                                              }}
                                            >
                                              <Typography
                                                style={{
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                }}
                                                sx={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  overflow: "hidden",
                                                  WebkitLineClamp: 1, // Limits to 1 lines
                                                  textOverflow: "ellipsis",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                Other2
                                              </Typography>
                                            </Button>
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </Box>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      minWidth: "100px",
                                      maxWidth: "120px",
                                    }}
                                    align="left"
                                  >
                                    <Typography variant="body2">
                                      {materialRow.last_updated
                                        ? moment(
                                            materialRow.last_updated
                                          ).format("YYYY-MM-DD HH:mm:ss")
                                        : ""}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={13}>
                  <Box style={{ display: "flex", justifyContent: "center" }}>
                    {/* <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> */}
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={13}
                count={data.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* /////////// Modal confirm grounding search /////////// */}
      <Modal open={openModalInsert}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {/* Insert product */}
              {t("genboq.popup.addjob.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModalInsert}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {/* Do you want to confirm Insert product ? */}
            {t("genboq.popup.addjob.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalInsert}
              loading={loadingBtnGrounding}
              loadingPosition="start"
              startIcon={<SearchIcon />}
              variant="contained"
              size="small"
            >
              {t("genboq.button.insertjob")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="medium"
              onClick={handleCloseModalInsert}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
